function ArrowLeftIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <g clip-path="url(#clip0_702_130)">
        <path d="M18 9C18 7.21997 17.4722 5.47991 16.4832 3.99987C15.4943 2.51983 14.0887 1.36628 12.4442 0.685088C10.7996 0.00389957 8.99002 -0.17433 7.24419 0.172937C5.49836 0.520204 3.89472 1.37737 2.63604 2.63604C1.37737 3.89472 0.520204 5.49836 0.172937 7.24419C-0.17433 8.99002 0.00389957 10.7996 0.685088 12.4442C1.36628 14.0887 2.51983 15.4943 3.99987 16.4832C5.47991 17.4722 7.21997 18 9 18C11.3862 17.9974 13.6738 17.0484 15.3611 15.3611C17.0484 13.6738 17.9974 11.3862 18 9ZM6.4395 10.0605C6.1583 9.77921 6.00032 9.39775 6.00032 9C6.00032 8.60226 6.1583 8.2208 6.4395 7.9395L9.94425 4.43475L11.0048 5.49525L7.5 9L11.0333 12.534L9.975 13.5945L6.4395 10.0605Z" />
      </g>
      <defs>
        <clipPath id="clip0_702_130">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ArrowLeftIcon;